import React from 'react'
import { Redirect } from 'react-router-dom'

export const CoachingRedirect = () => {
  return <Redirect to="/playlists" />
}
